import React from "react";
import { useTranslation } from "react-i18next";
import { getCurrencySymbol } from "../lib/Utils";

const LockerDetailsComponent = ({ locker, variant = "default", onBook }) => {
  const { t } = useTranslation();

  // Default values if locker data is not provided
  const {
    name = t("locker_details_default_name"),
    address = t("address_shown_after_booking"),
    city = "",
    price = "₹30/hr",
    backgroundImage = "https://via.placeholder.com/400x200/2196f3/ffffff?text=Storage+Spot",
    logoImage = "",
    available = 0,
    distance = "",
    description = "",
    lockerNumber = "",
    currency = "INR",
  } = locker || {};

  // Get location string
  const getLocation = () => {
    if (address && city) return `${address}, ${city}`;
    if (address) return address;
    if (city) return city;
    return t("location_available_after_booking");
  };

  console.log("currency in LockerDetailsComponent: ", currency);

  return (
    <div className="storage-card">
      {/* Image Section */}
      <div className="image-container">
        <img
          src={backgroundImage}
          alt={name}
          className="image"
          onError={(e) => {
            e.target.src =
              "https://via.placeholder.com/400x200/2196f3/ffffff?text=Storage+Spot";
          }}
        />
      </div>

      {/* Content Section */}
      <div className="content">
        <div className="header">
          <h2 className="title">{name}</h2>

          <div className="badge-container">
            <span className="badge badge-open">{t("open_24h_badge")}</span>
            {distance && (
              <span className="badge badge-distance">{distance} km</span>
            )}
          </div>

          <div className="info-line">
            <span className="everyday">{t("every_day_text")}</span>
            {lockerNumber && (
              <span className="locker">
                {t("locker_number_label", { lockerNumber })}
              </span>
            )}
          </div>
        </div>

        {description && (
          <div className="description">
            <p>{description}</p>
          </div>
        )}

        <div className="address-section">
          <p className="address-label">
            <span className="address-icon">📍</span>
            {getLocation()}
          </p>
          <div className="divider"></div>
        </div>

        <div className="hours">
          <h3 className="subtitle">{t("opening_hours_title")}</h3>
          <p className="hours-text">{t("open_24_hours_every_day_text")}</p>
        </div>

        <div className="includes">
          <h3 className="subtitle">{t("booking_includes_title")}</h3>

          <div className="feature">
            <span className="feature-icon">✓</span>
            <div className="feature-content">
              <strong>{t("free_cancellation_title")}</strong>
              {/* <p>{t("free_cancellation_description")}</p> */}
               <p>Cancel up to 3 hours before locker check in time. </p>
            </div>
          </div>
         <div className="feature">
            <span className="feature-icon">💬</span>
            <div className="feature-content">
              <strong>{t("support_24_7_title")}</strong>
              <p>{t("support_24_7_description")}</p>
              <p className="phone-number">1800 267 8737</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer with Price and Button */}
      <div className="footer">
        <div className="price-section">
          <div className="price-box">
            <div className="price">  
              { "From " + getCurrencySymbol(currency)} {price}
            </div>
            <div className="duration">{"Per Day"}</div>
          </div>

          <button className="button" onClick={onBook}>
            {t("select_lockers_button")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LockerDetailsComponent;
